var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 88.122,
    height: 44.078,
    viewBox: "0 0 88.122 44.078",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 18.821,
    height: 27.632,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21",
    "data-name": "Groupe 21",
    transform: "translate(-4240.064 411.524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_156",
    "data-name": "Trac\\xE9 156",
    d: "M732.164,235.721c0-8.483-5.746-14.337-13.7-14.337h-.051v3.274h.051c5.532,0,9.559,3.868,10.041,9.4H704.748c-.054.543-.08,1.1-.08,1.664,0,8.377,6.014,14.391,14.823,14.391l.106-3.382c-6.174,0-10.687-3.922-11.115-9.827H732.11c0-.431.054-.859.054-1.182",
    transform: "translate(3559.542 -620.482)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_157",
    "data-name": "Trac\\xE9 157",
    d: "M662.364,182.476h8.183l11.7,13.816-11.7,13.816h-8.183l11.7-13.816Z",
    transform: "translate(3588.336 -594)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_158",
    "data-name": "Trac\\xE9 158",
    d: "M662.364,229.114,678.1,210.4l4.146,4.9-11.7,13.816Z",
    transform: "translate(3588.336 -613.006)",
    fill: "#191847"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_19",
    "data-name": "Groupe 19",
    transform: "translate(4240.064 -411.524)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_18",
    "data-name": "Groupe 18",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_17",
    "data-name": "Groupe 17",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_159",
    "data-name": "Trac\\xE9 159",
    d: "M647.885,182.476l-10.644,27.632h-8.177l10.644-27.632Z",
    transform: "translate(-629.064 -182.476)",
    fill: "#8612ad"
  })))), /*#__PURE__*/React.createElement("text", {
    id: "v",
    transform: "translate(4291.706 -386.578)",
    fill: "#fff",
    fontSize: 19,
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "v")), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "//",
    transform: "translate(4295.685 -372.917)",
    fill: "#191847",
    fontSize: 21,
    fontFamily: "Exo2-SemiBoldItalic, 'Exo \\\\\\\\32 '",
    fontWeight: 600,
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: "-0.1em"
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "/")), /*#__PURE__*/React.createElement("text", {
    id: "e",
    transform: "translate(4315.186 -372.446)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "e")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.04dc2cb1b9d8fad08ac3dd2a3f793ea8.svg";
export { ForwardRef as ReactComponent };